'use client';

import { useRouter } from 'next/navigation';
import { Suspense, useCallback, useEffect, useState } from 'react';
import { BlogLoadingSkeleton } from '@/components/blog/blog-loading-skeleton';

import { CategoryParamsWatcher } from './CategoryParamsWatcher';

export default function CategoryChangeHandler({
	children,
}: {
	children: React.ReactNode;
}) {
	const router = useRouter();
	const [isLoading, setIsLoading] = useState(false);

	const handleNavigateComplete = useCallback(() => {
		setIsLoading(false);
	}, []);

	useEffect(() => {
		const handleClick = (e: MouseEvent) => {
			const target = e.target as HTMLElement;
			const link = target.closest('a');

			if (
				link &&
				(link.classList.contains('category-link') ||
					link.classList.contains('pagination-link') ||
					(link.href.includes('/blog') &&
						(link.href.includes('category=') ||
							link.href.includes('page='))))
			) {
				e.preventDefault();
				setIsLoading(true);
				router.push(link.href);
			}
		};

		document.addEventListener('click', handleClick);
		return () => document.removeEventListener('click', handleClick);
	}, [router]);

	return (
		<>
			<Suspense fallback={null}>
				<CategoryParamsWatcher
					onNavigateComplete={handleNavigateComplete}
				/>
			</Suspense>
			{isLoading ? <BlogLoadingSkeleton /> : null}
			<div className={isLoading ? 'hidden' : undefined}>{children}</div>
		</>
	);
}
